var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-boards',{attrs:{"board-key":"sw_examples"}})
}
var staticRenderFns = []

export { render, staticRenderFns }